import Handlebars from 'handlebars';
import { ShopListingProductBlock } from './shopListingProductBlock';

const NS = 'ShopListingByCategoryBlock';
const CLS = 'shopListingByCategoryBlock';

export class ShopListingByCategoryBlock {
	constructor(element) {
		// $el is the widget node return by the loadShopProductBlock function
		this.$el = $(element);
		this.$searchResultsEmpty = this.$el.find(`.${CLS}-searchResults-empty`);
		this.$shopProducts = this.$el.find(`.${CLS}-products`);
		this.$loadMoreBtn = this.$el.find(`.${CLS}-loadMore-btn`);
		this.$loadingScreen = this.$el.find(`.${CLS}-searchResults-loadingScreen`);
		this.$loadMore = this.$el.find(`.${CLS}-searchResults-loadMore`);

		this.getCategory = this.$el.data('category');
		this.getProductsApi = this.$el.data('productsApi');
		this.getPageSize = this.$el.data('pageSize');
		this.getLoadMore = this.$el.data('loadMore');
		this.loadingProducts = false;
		this.allProductsLoaded = false;
		this.pageSize = this.getPageSize;
		this.pageNumber = 1;
		this.$productBlock = [];
		this.initParams();
		if(this.getLoadMore == "True"){
			this.handleScrollLoading(this.getLoadMore);
		}
		this.getItems(false);
	}

	initParams(){
			this.params = {
				// siteId: this.siteId,
				category: this.getCategory,
				count: this.pageSize,
				offset: 0,
			};
	}

	getShopListingProductBlockTemplate() {
		let shopListingProductBlock = require('../../partials/widgets/shopListingProductBlock.hbs');
		Handlebars.registerPartial('shopListingProductBlock', shopListingProductBlock);

		let template = `
			{{> shopListingProductBlock
				wg="shopListingProductBlock"
				ns="ShopListingProductBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	// Get items (reload content)
	getItems(loadMoreProducts) {
		if (!this.loadingProducts && !this.allProductsLoaded) {
			this.loadingProducts = true;

			let url = this.getProductsApi;

			if (loadMoreProducts) {
				this.setPageNumber(this.pageNumber + 1);
				this.$loadMore.addClass('active');
			} else {
				this.$loadingScreen.addClass('active');
			}
			if (!_.isEmpty(this.params)) {
				url += `?${$.param(this.params)}`;
			}

			$.ajax({
				type: 'GET',
				url: url,
				success: (data) => {
					this.$searchResultsEmpty.hide();

					if (!loadMoreProducts) {
						this.$shopProducts.empty();
					}

					if (data.length > 0) {
						data.forEach((item) => {
							let $column = this.$shopProducts.append(this.getShopListingProductBlockTemplate()(item));
							new ShopListingProductBlock($column.find(`[data-wg="ShopListingProductBlock"]`).last()[0], item);
						});

					} else {
						if (loadMoreProducts) {
							this.allProductsLoaded = true;
						} else {
							this.$searchResultsEmpty.show();
						}
					}

					this.$loadingScreen.removeClass('active');
					this.$loadMore.removeClass('active');
				},
				error: (error) => {

				},
				complete: () => {
					this.loadingProducts = false;
				},
			});
		}
	}

	handleScrollLoading() {
		let offsetFromBottom = 10;
		const This = this;
		$(document).on('touchmove', onScroll); // for mobile
		function onScroll() {
			if ($(window).scrollTop() + offsetFromBottom > $(document).height() - $(window).height()-400) {
				This.getItems(true);
			}
		}
		$(window).scroll(function() {
			let position = $(window).scrollTop() + offsetFromBottom;
			let bottom = $(document).height() - $(window).height();

			if ( position >= bottom ) {
			   This.getItems(true);
			}
		 });
	}

	setPageNumber(newPageNumber) {
		this.pageNumber = newPageNumber;
		this.params.offset = (this.pageNumber - 1) * this.pageSize;
	}
}
